import { StoryElementType } from 'webapp/enums/enums';

import StoryElementBase from 'webapp/models-custom/story-element/base';

export default class StoryElementGranulationLabel extends StoryElementBase {
	type = StoryElementType.GRANULATION_LABEL;
	longTitle = 'Date label';

	override get isLoading(): boolean {
		return super.isLoading || !this.dataPoint;
	}

	openEdit(_node: HTMLElement): void {
		this.openAdvanced();
	}

	fillElementContent(node: HTMLElement): void {
		const text = this.dataPoint?.granulationLabel?.labelLong || '<unknown>';
		node.textContent = text;
	}
}
